// SafeForm.ai service worker registration
export function registerSW() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  // Only register in production-style builds to avoid HMR conflicts in dev
  if (process.env.NODE_ENV !== "production") return;
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { updateViaCache: "none" })
      .then((reg) => reg.update())
      .catch((err) => console.warn("[SW] register failed", err));
  });
}
